module.exports = __webpack_public_path__ + "img/square-this-way-up.3a72dc05.svg";